import { useState, useEffect } from "react"
import { useUpdateGradeMutation } from "../responses/responsesApiSlice"

import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAlignLeft, faAlignRight, faSave, faTrashCan, faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons"
import { useParams } from "react-router-dom"
import ReactQuill from 'react-quill';
import useQueryParams from "../../hooks/useQueryParams"
import { FriendsCheckbox } from "../../components/FriendsCheckbox"
import ResponseGradeStepsMain from "./grade-steps/ResponseGradeStepsMain"

const EditGrade = ({response}) => {
   
   const {groupId, taskId, type} = useParams()
   const { q, qName } = useQueryParams()
    const navigate = useNavigate()
    const [updateGrade, {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateGradeMutation()


    useEffect(() => {

        if (isSuccess ) {
            setGrade(0)
            setNotes('')
            backClick()
        }

    }, [isSuccess, navigate])
    useEffect(() => {
        if(response?.task?.gradeSteps && response?.task?.gradeSteps.length > 0 && (!response.responseGradeSteps || response.responseGradeSteps.length === 0)){
            setResponseGradeSteps(response.task.gradeSteps)
        }
    },[])
    const [grade, setGrade] = useState(response.grade)
    const [notes, setNotes] = useState(response.notes)
    const [adminComments, setAdminComments] = useState(response.adminComments)
    const [otherFriends, setOtherFriends] = useState([])
    const [allRelated, setAllRelated] = useState(response.task?.defaultCheckInclueRelatedFriends)
    const [responseGradeSteps, setResponseGradeSteps] = useState(response.responseGradeSteps || [])

    const canSave = [grade].every(Boolean) && !isLoading

    const onSaveResponseClicked = async (e) => {
        if (canSave) {
            await updateGrade({ id: response.id, grade, notes,allRelated, adminComments, otherFriends, responseGradeSteps })
        }
    }

    const backClick = ()=>{
        if(q || qName){
            const t = taskId || "0"
            navigate(`/${type}/${groupId}/grades/task/${t}/search?q=${encodeURIComponent( q)}&qName=${encodeURIComponent(qName)}`) 
        }else{
        if(taskId!=='0')
            navigate(`/${type}/${groupId}/grades/task/${taskId}`)
        else
            navigate(`/${type}/${groupId}/grades`)
        }
    }

    const updateGradeFromSteps=(total)=>{
        setGrade(total)
    }
    

    const errClass = isError ? "errmsg" : "offscreen"

    const errContent = (error?.data?.message) ?? ''

    const content = (
        <>
      
            <p className={errClass}>{errContent}</p>
            <form className="form"  onSubmit={e => e.preventDefault()}>
                


         

                <div className="form__title-row">

                     <h2>עריכת ציון</h2>
                     <div className="form__action-buttons">

                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                            onClick={onSaveResponseClicked}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <button
                            className="icon-button"
                            title="Back to action"
                            onClick={backClick}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        </div>
                        
                    
                </div>
                <label className="form__label" htmlFor="grade">
                    ציון:</label>
                <input
                    className={`form__input  ${!grade &&'form__input--incomplete'}`}
                    id="grade"
                    name="grade"
                    type="number"
                    autoComplete="off"
                    value={grade}
                    onChange={(e)=>setGrade(e.target.value)}
                />
    
                <div className="form__row">
                <label className="form__label" htmlFor="notes">
                    הערות בודק</label>   
                        </div>

                        <ReactQuill
                     value={notes}
                    onChange={setNotes}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                         // [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          [{size: []}],
                          [{ color: [] }, { background: [] }],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />
                                    <ResponseGradeStepsMain updateGradeFromSteps={updateGradeFromSteps} responseGradeSteps={responseGradeSteps} setResponseGradeSteps={setResponseGradeSteps} />

                  <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="all-related">
                    ALL-RELATED (ציון אחיד גם לחברות):
                    <input
                        className="form__checkbox"
                        id="all-related"
                        name="all-related"
                        type="checkbox"
                        checked={allRelated}
                        onChange={(e)=>setAllRelated(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div>


                <FriendsCheckbox label="בנות נוספות לעדכון" group={response?.group} friends={otherFriends} setFriends={setOtherFriends} />


                </div>
                <div className="form__row">
                <label className="form__label" htmlFor="adminComments">
                    לשימוש משרדי</label>   
                        </div>

                 <textarea
                    className={`form__input   `}
                    id="adminComments"
                    name="adminComments"
                    value={adminComments}
                    onChange={(e)=>setAdminComments(e.target.value)}
                />              

               
           
         
            </form>
        </>
    )

    return content
}

export default EditGrade